// Development environment configuration
export const environment = {
    production: false,
    envName: 'development',
    apiUrl: 'https://etapa3.honeytokens-api.dev135.abacus-consulting.net',
    enableDebug: true,
    enableConsoleLog: true,
    version: '3.0.5-dev',
    features: {
        showDevTools: true,
        enableVerboseLogging: true,
        mockApiCalls: false
    }
};
